import { atom } from "recoil";

export const selectedOptionState = atom<string | false>({
  key: "selectedOptionState",
  default: "panel0",
});
